import { CreateSurchargeDisputeSchema } from "@redotech/redo-model/balance/surcharge-dispute";
import * as z from "zod/v4";

export const createSurchargeDispute = {
  name: "createSurchargeDispute" as const,
  input: CreateSurchargeDisputeSchema,
  output: z.object({ success: z.boolean() }),
};
